export default function(value: number | string | bigint | null): string {
    if (value === null) {
        return '-';
    }
    if (typeof value === 'number') {
        value = Math.round(value);
    }

    const bigIntValue = BigInt(value);
    const int = bigIntValue / BigInt(100);
    let frac = bigIntValue % BigInt(100);

    if (frac < 0) {
        frac = BigInt(Math.abs(Number(frac)));
    }

    return `${int}.${frac < BigInt(10) ? '0' : ''}${frac}`;
}
